import { Typography, styled } from '@mui/material';

export const SubHeader = styled(Typography)(() => ({
    marginBottom: '1.875rem',
    marginTop: '1.125rem',
    maxWidth: '37.5rem',
}));
